/* assets/wm-quickinfo.js
   wood & more – Mobile Quick-Info Bottom-Sheet + Desktop Popover
   - funktioniert global (Startseite, Kollektion, Produkt etc.)
   - CSS steuert Sichtbarkeit/Position des Info-Icons (z.B. complementary ausblenden)
   - keine Typography/Font-Size Anpassungen
*/

(function () {
  if (window.__wmQuickInfoInit) return;
  window.__wmQuickInfoInit = true;

  // Muss zur CSS-Logik passen (bei dir: @media (max-width: 749px))
  var MOBILE_MAX = 749;
  var mql = window.matchMedia("(max-width:" + MOBILE_MAX + "px)");
  function isMobile() {
    return mql.matches;
  }
  function isDesktop() {
    return !mql.matches;
  }

  /* =======================
     WM: Desktop – Lupe in "Ergänzende Produkte" ausblenden
     (nur Desktop, sonst nichts)
     ======================= */
  (function ensureComplementaryDesktopHideCss() {
    if (document.getElementById("wm-quickinfo-hide-complementary-desktop")) return;
    var css = document.createElement("style");
    css.id = "wm-quickinfo-hide-complementary-desktop";
    css.textContent = `
      @media (min-width:${MOBILE_MAX + 1}px){
        complementary-products .wm-lens[data-wm-sheet],
        .complementary-products .wm-lens[data-wm-sheet],
        [data-section-type="complementary-products"] .wm-lens[data-wm-sheet]{
          display:none !important;
        }
      }
    `;
    document.head.appendChild(css);
  })();

  function escHtml(s) {
    return String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function safeParseJSON(val, fallback) {
    try {
      var out = JSON.parse(val);
      return Array.isArray(out) ? out : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function renderLines(items) {
    if (!items || !items.length) return "";
    return (
      '<div class="wm-sheet__lines">' +
      items
        .filter(function (t) {
          return String(t).trim() !== "";
        })
        .map(function (t) {
          return '<div class="wm-sheet__line">' + escHtml(t) + "</div>";
        })
        .join("") +
      "</div>"
    );
  }

  // ---- Sheet Markup + CSS (nur wenn noch nicht vorhanden) ----
  function ensureSheetCss() {
    if (document.getElementById("wm-quickinfo-sheet-css")) return;

    var css = document.createElement("style");
    css.id = "wm-quickinfo-sheet-css";
    css.textContent = `
      .wm-sheet{ position:fixed; inset:0; z-index:9999; display:none; }
      .wm-sheet.is-open{ display:block; }

      .wm-sheet__backdrop{ position:absolute; inset:0; background:rgba(0,0,0,.64); }

      .wm-sheet__panel{
        position:absolute; left:0; right:0; bottom:0;
        background:rgb(var(--color-background, 255,255,255));
        color:rgb(var(--color-foreground, 0,0,0));
        border-top-left-radius:18px;
        border-top-right-radius:18px;
        max-height:86vh;
        overflow:auto;
        -webkit-overflow-scrolling:touch;
        box-shadow:0 -30px 100px rgba(0,0,0,.46);
        border-top:1px solid rgba(0,0,0,.10);
        outline:none;
      }

      .wm-sheet__content{ padding:16px 16px 18px; }
      .wm-sheet__handle{
        width:56px; height:6px; border-radius:999px;
        background:rgba(0,0,0,.20);
        margin:10px auto 10px;
      }

      .wm-sheet__close{
        position:absolute; right:12px; top:12px;
        width:42px; height:42px;
        border-radius:999px;
        border:1px solid rgba(0,0,0,.14);
        background:rgba(255,255,255,.94);
        box-shadow:0 12px 28px rgba(0,0,0,.20);
        cursor:pointer;
        display:flex; align-items:center; justify-content:center;
        padding:0;
      }
      .wm-sheet__close svg{
        width:20px; height:20px;
        stroke:rgba(0,0,0,.78);
        stroke-width:2.6;
        fill:none;
        stroke-linecap:round;
      }

      .wm-sheet__kicker{
        display:inline-flex;
        align-items:center;
        padding:6px 10px;
        border-radius:999px;
        font-weight:700;
        background:rgba(181,74,42,.14);
        border:1px solid rgba(181,74,42,.22);
        margin-bottom:10px;
      }
      .wm-sheet__title{ margin:0 0 10px; }

      .wm-sheet__lines{ display:grid; gap:8px; }
      .wm-sheet__line{ opacity:.95; }

      .wm-sheet__cta{
        display:grid;
        grid-template-columns:1fr;
        gap:10px;
        margin-top:14px;
      }
      .wm-sheet__primary,
      .wm-sheet__secondary{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        padding:13px 14px;
        border-radius:12px;
        text-decoration:none;
      }
      .wm-sheet__primary{
        background:#B54A2A;
        color:#fff;
        border:1px solid rgba(0,0,0,.12);
        box-shadow:0 14px 32px rgba(0,0,0,.18);
        font-weight:700;
      }
      .wm-sheet__secondary{
        background:transparent;
        color:inherit;
        border:1px solid rgba(0,0,0,.22);
        opacity:.96;
        font-weight:600;
        cursor:pointer;
      }

      .wm-sheet__trust{
        margin-top:14px;
        padding-top:12px;
        border-top:1px solid rgba(0,0,0,.12);
        opacity:.95;
      }

      @media (min-width:${MOBILE_MAX + 1}px){
        .wm-sheet{ display:none !important; }
      }
    `;
    document.head.appendChild(css);
  }

  function ensureSheetDom() {
    if (document.getElementById("wmSheet")) return;

    var wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="wm-sheet" id="wmSheet" aria-hidden="true">
        <div class="wm-sheet__backdrop" data-wm-sheet-close></div>
        <div class="wm-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="wmSheetTitle" tabindex="-1">
          <button class="wm-sheet__close" type="button" aria-label="Schließen" data-wm-sheet-close>
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6 6 L18 18"></path>
              <path d="M18 6 L6 18"></path>
            </svg>
          </button>
          <div class="wm-sheet__handle" aria-hidden="true"></div>
          <div class="wm-sheet__content">
            <div class="wm-sheet__header">
              <div class="wm-sheet__kicker" id="wmSheetKicker">Quick-Info</div>
              <h3 class="wm-sheet__title" id="wmSheetTitle"></h3>
            </div>
            <div class="wm-sheet__body" id="wmSheetBody"></div>
            <div class="wm-sheet__cta">
              <a class="wm-sheet__primary" id="wmSheetPrimary" href="#">Zum Produkt</a>
              <button class="wm-sheet__secondary" type="button" data-wm-sheet-close>Weiter stöbern</button>
            </div>
            <div class="wm-sheet__trust" id="wmSheetTrust"></div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap.firstElementChild);
  }

  function getSheetEls() {
    var sheet = document.getElementById("wmSheet");
    return {
      sheet: sheet,
      panel: sheet.querySelector(".wm-sheet__panel"),
      titleEl: sheet.querySelector("#wmSheetTitle"),
      kickerEl: sheet.querySelector("#wmSheetKicker"),
      bodyEl: sheet.querySelector("#wmSheetBody"),
      trustEl: sheet.querySelector("#wmSheetTrust"),
      primaryEl: sheet.querySelector("#wmSheetPrimary"),
    };
  }

  var lastFocus = null;

  function openSheet(trigger) {
    if (!isMobile()) return;

    ensureSheetCss();
    ensureSheetDom();

    var els = getSheetEls();

    lastFocus = document.activeElement;

    var title = trigger.getAttribute("data-title") || "Infos";
    var kicker = trigger.getAttribute("data-kicker") || "Quick-Info";
    var url = trigger.getAttribute("data-url") || "#";

    var body = safeParseJSON(trigger.getAttribute("data-body") || "[]", []);
    var trust = safeParseJSON(trigger.getAttribute("data-trust") || "[]", []);

    els.titleEl.textContent = title;
    els.kickerEl.textContent = kicker;
    els.bodyEl.innerHTML = renderLines(body);
    els.trustEl.innerHTML = renderLines(trust);
    els.primaryEl.setAttribute("href", url);

    els.sheet.classList.add("is-open");
    els.sheet.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    els.panel.focus({ preventScroll: true });
  }

  function closeSheet() {
    var sheet = document.getElementById("wmSheet");
    if (!sheet) return;

    sheet.classList.remove("is-open");
    sheet.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";

    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus({ preventScroll: true });
    }
  }

  // ---- Desktop Popover (CSS + DOM) ----
  function ensurePopoverCss() {
    if (document.getElementById("wm-quickinfo-popover-css")) return;

    var css = document.createElement("style");
    css.id = "wm-quickinfo-popover-css";
    css.textContent = `
      .wm-qipop{ position:fixed; inset:0; z-index:9999; display:none; }
      .wm-qipop.is-open{ display:block; }
      .wm-qipop__backdrop{ position:absolute; inset:0; background:rgba(0,0,0,.22); }
      .wm-qipop__panel{
        position:absolute;
        width:clamp(420px, 42vw, 560px);
        max-width:calc(100vw - 36px);
        background:rgb(var(--color-background, 255,255,255));
        color:rgb(var(--color-foreground, 0,0,0));
        border-radius:16px;
        box-shadow:0 24px 80px rgba(0,0,0,.28);
        border:1px solid rgba(0,0,0,.10);
        overflow:hidden;
      }
      .wm-qipop__content{ padding:14px 14px 14px; }
      .wm-qipop__kicker{
        display:inline-flex;
        align-items:center;
        padding:6px 10px;
        border-radius:999px;
        font-weight:700;
        background:rgba(181,74,42,.14);
        border:1px solid rgba(181,74,42,.22);
        margin-bottom:10px;
      }
      .wm-qipop__title{ margin:0 0 10px; }
      .wm-qipop__lines{ display:grid; gap:8px; }
      .wm-qipop__line{ opacity:.95; }
      .wm-qipop__cta{
        display:flex;
        gap:10px;
        margin-top:14px;
      }
      .wm-qipop__primary,
      .wm-qipop__secondary{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        padding:11px 12px;
        border-radius:12px;
        text-decoration:none;
        white-space:nowrap;
      }
      .wm-qipop__primary{
        background:#B54A2A;
        color:#fff;
        border:1px solid rgba(0,0,0,.12);
        box-shadow:0 14px 32px rgba(0,0,0,.16);
        font-weight:700;
        flex:1;
      }
      .wm-qipop__secondary{
        background:transparent;
        color:inherit;
        border:1px solid rgba(0,0,0,.22);
        opacity:.96;
        font-weight:600;
        cursor:pointer;
      }
      .wm-qipop__trust{
        margin-top:14px;
        padding-top:12px;
        border-top:1px solid rgba(0,0,0,.12);
        opacity:.95;
      }
      .wm-qipop__close{
        position:absolute; right:10px; top:10px;
        width:38px; height:38px;
        border-radius:999px;
        border:1px solid rgba(0,0,0,.14);
        background:rgba(255,255,255,.94);
        box-shadow:0 12px 28px rgba(0,0,0,.16);
        cursor:pointer;
        display:flex; align-items:center; justify-content:center;
        padding:0;
      }
      .wm-qipop__close svg{
        width:18px; height:18px;
        stroke:rgba(0,0,0,.78);
        stroke-width:2.6;
        fill:none;
        stroke-linecap:round;
      }

      @media (max-width:${MOBILE_MAX}px){
        .wm-qipop{ display:none !important; }
      }
    `;
    document.head.appendChild(css);
  }

  function ensurePopoverDom() {
    if (document.getElementById("wmQIPop")) return;

    var wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="wm-qipop" id="wmQIPop" aria-hidden="true">
        <div class="wm-qipop__backdrop" data-wm-pop-close></div>
        <div class="wm-qipop__panel" role="dialog" aria-modal="true" aria-labelledby="wmQIPopTitle" tabindex="-1">
          <button class="wm-qipop__close" type="button" aria-label="Schließen" data-wm-pop-close>
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6 6 L18 18"></path>
              <path d="M18 6 L6 18"></path>
            </svg>
          </button>
          <div class="wm-qipop__content">
            <div class="wm-qipop__header">
              <div class="wm-qipop__kicker" id="wmQIPopKicker">Quick-Info</div>
              <h3 class="wm-qipop__title" id="wmQIPopTitle"></h3>
            </div>
            <div class="wm-qipop__body" id="wmQIPopBody"></div>
            <div class="wm-qipop__cta">
              <a class="wm-qipop__primary" id="wmQIPopPrimary" href="#">Zum Produkt</a>
              <button class="wm-qipop__secondary" type="button" data-wm-pop-close>Schließen</button>
            </div>
            <div class="wm-qipop__trust" id="wmQIPopTrust"></div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap.firstElementChild);
  }

  function getPopEls() {
    var pop = document.getElementById("wmQIPop");
    return {
      pop: pop,
      panel: pop.querySelector(".wm-qipop__panel"),
      titleEl: pop.querySelector("#wmQIPopTitle"),
      kickerEl: pop.querySelector("#wmQIPopKicker"),
      bodyEl: pop.querySelector("#wmQIPopBody"),
      trustEl: pop.querySelector("#wmQIPopTrust"),
      primaryEl: pop.querySelector("#wmQIPopPrimary"),
    };
  }

  function setPopoverPosition(panel, triggerEl) {
    // Positioniert das Panel möglichst "neben" dem Icon, aber im Viewport sicher
    var r = triggerEl.getBoundingClientRect();
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    var panelW = panel.offsetWidth || 420;
    var panelH = panel.offsetHeight || 320;

    var gap = 12;
    var left = r.right + gap; // rechts vom Icon
    var top = r.top - 6;

    // Wenn rechts kein Platz -> links vom Icon
    if (left + panelW > vw - 18) {
      left = Math.max(18, r.left - gap - panelW);
    }

    // Vertikal clamp
    if (top + panelH > vh - 18) {
      top = Math.max(18, vh - 18 - panelH);
    }
    if (top < 18) top = 18;

    panel.style.left = left + "px";
    panel.style.top = top + "px";
  }

  function openPopover(trigger) {
    if (!isDesktop()) return;

    ensurePopoverCss();
    ensurePopoverDom();

    var els = getPopEls();
    lastFocus = document.activeElement;

    var title = trigger.getAttribute("data-title") || "Infos";
    var kicker = trigger.getAttribute("data-kicker") || "Quick-Info";
    var url = trigger.getAttribute("data-url") || "#";

    var body = safeParseJSON(trigger.getAttribute("data-body") || "[]", []);
    var trust = safeParseJSON(trigger.getAttribute("data-trust") || "[]", []);

    els.titleEl.textContent = title;
    els.kickerEl.textContent = kicker;
    els.bodyEl.innerHTML = renderLines(body).replaceAll("wm-sheet__", "wm-qipop__");
    // Trust auch als Lines
    els.trustEl.innerHTML = renderLines(trust).replaceAll("wm-sheet__", "wm-qipop__");
    els.primaryEl.setAttribute("href", url);

    els.pop.classList.add("is-open");
    els.pop.setAttribute("aria-hidden", "false");

    // Erst anzeigen, dann positionieren (damit offsetWidth/Height stimmt)
    requestAnimationFrame(function () {
      setPopoverPosition(els.panel, trigger);
      els.panel.focus({ preventScroll: true });
    });
  }

  function closePopover() {
    var pop = document.getElementById("wmQIPop");
    if (!pop) return;

    pop.classList.remove("is-open");
    pop.setAttribute("aria-hidden", "true");

    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus({ preventScroll: true });
    }
  }

  /* =========================================================
     WM: DESKTOP – Produktkachel klickbar machen (auch auf Bild)
     - Öffnet data-wm-card-url bei Klick in .card__inner
     - Ausnahme: echte Interaktionen + Lupe-Icon (SVG) => Quickinfo
     ========================================================= */
  function isInteractiveTargetDesktop(el) {
    return !!(
      el.closest("a") ||
      el.closest("button") ||
      el.closest("product-form") ||
      el.closest("modal-opener")
    );
  }

  function clickedLensIcon(el) {
    var lens = el.closest(".wm-lens[data-wm-sheet]");
    if (!lens) return false;
    var svg = el.closest("svg");
    return !!(svg && lens.contains(svg));
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!isDesktop()) return;

      var inner = e.target.closest('.card__inner[data-wm-card-url]');
      if (!inner) return;

      var url = inner.getAttribute("data-wm-card-url");
      if (!url) return;

      // Normale interaktive Elemente nicht überschreiben
      if (isInteractiveTargetDesktop(e.target)) return;

      // Wenn wirklich auf das Lupe-Icon geklickt wurde, NICHT navigieren (Quickinfo soll öffnen)
      if (clickedLensIcon(e.target)) return;

      // Alles andere in der Kachel (inkl. Bild) => navigieren
      window.location.href = url;
    },
    true
  );

  // --- Events: Icon öffnen (capture => stabil in Slidern/overlays) ---
  document.addEventListener(
    "pointerdown",
    function (e) {
      var lens = e.target.closest(".wm-lens[data-wm-sheet]");
      if (!lens) return;

      // NUR wenn wirklich das Icon/SVG getroffen wird, abfangen
      if (!clickedLensIcon(e.target)) return;

      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var lens = e.target.closest(".wm-lens[data-wm-sheet]");
      if (!lens) return;

      // NUR wenn wirklich das Icon/SVG getroffen wird, Quickinfo öffnen
      if (!clickedLensIcon(e.target)) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // Mobile: Bottom-Sheet (wie vorher)
      if (isMobile()) {
        openSheet(lens);
        return;
      }

      // Desktop: Popover
      openPopover(lens);
    },
    true
  );

  // Sheet schließen: Klick auf Backdrop oder Close-Buttons (Mobile) + Popover schließen (Desktop)
  document.addEventListener(
    "click",
    function (e) {
      var sheet = document.getElementById("wmSheet");
      if (sheet && sheet.classList.contains("is-open") && isMobile()) {
        if (e.target.closest("[data-wm-sheet-close]")) {
          e.preventDefault();
          closeSheet();
        }
        return;
      }

      // Popover schließen (Desktop)
      var pop = document.getElementById("wmQIPop");
      if (pop && pop.classList.contains("is-open") && isDesktop()) {
        // 1) Explizite Close Targets (Backdrop/Buttons)
        if (e.target.closest("[data-wm-pop-close]")) {
          e.preventDefault();
          closePopover();
          return;
        }

        // 2) ROBUST: Klick irgendwo außerhalb des Panels schließt ebenfalls
        var panel = pop.querySelector(".wm-qipop__panel");
        var clickedInsidePanel = !!(panel && e.target.closest(".wm-qipop__panel"));
        var clickedLens = !!e.target.closest(".wm-lens[data-wm-sheet]");

        if (!clickedInsidePanel && !clickedLens) {
          e.preventDefault();
          closePopover();
        }
      }
    },
    true
  );

  // ESC schließt
  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Escape") return;

      var sheet = document.getElementById("wmSheet");
      if (sheet && sheet.classList.contains("is-open") && isMobile()) {
        closeSheet();
        return;
      }

      var pop = document.getElementById("wmQIPop");
      if (pop && pop.classList.contains("is-open") && isDesktop()) {
        closePopover();
      }
    },
    true
  );

  /* =========================================================
     WM: Tap-Navigation für Bildbereich (Slider-safe)
     - Start+Ende innerhalb derselben .card__inner[data-wm-card-url]
     - Nur Tap (kein Drag)
     - Navigiert nicht, wenn echtes Interaktions-Element getroffen
     ========================================================= */
  (function () {
    var tap = null;
    var DRAG_T = 10;

    function isInteractiveTarget(el) {
      return !!(
        el.closest("a") ||
        el.closest("button") ||
        el.closest("product-form") ||
        el.closest("modal-opener") ||
        el.closest(".wm-lens")
      );
    }

    document.addEventListener(
      "pointerdown",
      function (e) {
        if (!isMobile()) return;

        var inner = e.target.closest('.card__inner[data-wm-card-url]');
        if (!inner) return;

        if (isInteractiveTarget(e.target)) return;

        tap = {
          x: e.clientX,
          y: e.clientY,
          inner: inner,
          url: inner.getAttribute("data-wm-card-url"),
        };
      },
      true
    );

    function clearTap() {
      tap = null;
    }

    document.addEventListener(
      "pointerup",
      function (e) {
        if (!tap) return;

        var dx = Math.abs(e.clientX - tap.x);
        var dy = Math.abs(e.clientY - tap.y);
        var moved = dx > DRAG_T || dy > DRAG_T;

        var endInner = e.target.closest('.card__inner[data-wm-card-url]');
        var same = endInner && endInner === tap.inner;

        if (!moved && same && tap.url) {
          window.location.href = tap.url;
        }
        clearTap();
      },
      true
    );

    document.addEventListener("pointercancel", clearTap, true);
  })();
})();